import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoAgro = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 166.914,
	height: 43.988,
	viewBox: "0 0 166.914 43.988",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "logo-agro",
		transform: "translate(-46.095 -658.161)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Grupo_296",
			"data-name": "Grupo 296",
			transform: "translate(89.546 675.469)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_546",
					"data-name": "Trazado 546",
					d: "M113.25,691.058H111.4l-3.3-6.637-2.505,5.1h3.773l1.014,1.536h-7.353l5.071-10.217Z",
					transform: "translate(-103.033 -680.841)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_547",
					"data-name": "Trazado 547",
					d: "M115.971,686.673a4.529,4.529,0,0,1,.373-1.827,4.7,4.7,0,0,1,2.505-2.5,4.633,4.633,0,0,1,1.85-.372,4.213,4.213,0,0,1,1.372.224,5.015,5.015,0,0,1,2.26,1.566,5.3,5.3,0,0,1,.753,1.223l-1.3.865a4.445,4.445,0,0,0-.552-.909,4.213,4.213,0,0,0-.73-.731,3.3,3.3,0,0,0-.858-.485,2.624,2.624,0,0,0-.933-.172,3,3,0,0,0-1.23.254,3.192,3.192,0,0,0-1,.686,3.4,3.4,0,0,0-.678,1,2.936,2.936,0,0,0,0,2.386,3.289,3.289,0,0,0,.678.992,3.162,3.162,0,0,0,1,.671,3.05,3.05,0,0,0,1.216.247,2.562,2.562,0,0,0,.858-.15,3.545,3.545,0,0,0,.82-.417,3.943,3.943,0,0,0,.723-.633,4.656,4.656,0,0,0,.582-.813l1.163,1.164a5.608,5.608,0,0,1-1.775,1.775,4.411,4.411,0,0,1-2.371.656,4.622,4.622,0,0,1-1.85-.373,4.7,4.7,0,0,1-2.505-2.5A4.528,4.528,0,0,1,115.971,686.673Zm8.726-.522v1.522h-4.788v-1.522Z",
					transform: "translate(-106.098 -681.11)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_548",
					"data-name": "Trazado 548",
					d: "M133.391,686.164h1.835a.737.737,0,0,0,.417-.119,1.03,1.03,0,0,0,.3-.306,1.317,1.317,0,0,0,.172-.41,1.935,1.935,0,0,0,.052-.433,1.613,1.613,0,0,0-.067-.455,1.674,1.674,0,0,0-.194-.433,1.111,1.111,0,0,0-.313-.328.713.713,0,0,0-.411-.127h-3.952v7.785h-1.6v-9.307h5.727a2.131,2.131,0,0,1,.939.217,2.427,2.427,0,0,1,.783.6,3.048,3.048,0,0,1,.537.917,3.183,3.183,0,0,1,.2,1.141,2.982,2.982,0,0,1-.15.933,3.036,3.036,0,0,1-.41.82,2.757,2.757,0,0,1-.619.627,2.027,2.027,0,0,1-.761.35l1.879,3.7h-1.744Z",
					transform: "translate(-109.334 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_549",
					"data-name": "Trazado 549",
					d: "M143.4,687.6a3.5,3.5,0,0,0,.44.843,3.744,3.744,0,0,0,.679.731,3.911,3.911,0,0,0,.887.552l-1.014,1.283a5.384,5.384,0,0,1-1.133-.791,5.072,5.072,0,0,1-.865-1.022,4.816,4.816,0,0,1-.552-1.193,4.447,4.447,0,0,1-.194-1.3,4.581,4.581,0,0,1,.366-1.813,4.678,4.678,0,0,1,1-1.491,4.753,4.753,0,0,1,1.5-1.007,4.816,4.816,0,0,1,3.713,0,4.706,4.706,0,0,1,2.506,2.5,4.507,4.507,0,0,1,.372,1.813,4.2,4.2,0,0,1-.208,1.319,4.788,4.788,0,0,1-.589,1.193,5.374,5.374,0,0,1-2.081,1.8l-.865-1.313a4.567,4.567,0,0,0,.865-.544,3.876,3.876,0,0,0,.694-.709,3.275,3.275,0,0,0,.455-.827,2.556,2.556,0,0,0,.164-.9,2.894,2.894,0,0,0-.253-1.193,3.223,3.223,0,0,0-.686-.992,3.356,3.356,0,0,0-1.007-.678,3.015,3.015,0,0,0-2.424,0,3.372,3.372,0,0,0-1,.678,3.113,3.113,0,0,0-.678.992,2.962,2.962,0,0,0-.246,1.193A2.625,2.625,0,0,0,143.4,687.6Z",
					transform: "translate(-112.181 -681.119)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_550",
					"data-name": "Trazado 550",
					d: "M155.587,682.033h1.059v9.307h-1.059Z",
					transform: "translate(-115.482 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_551",
					"data-name": "Trazado 551",
					d: "M160.853,691.34h-1.044v-9.307h1.744l5.892,8.427v-8.427h1.044v9.307h-1.641l-6-8.442Z",
					transform: "translate(-116.482 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_552",
					"data-name": "Trazado 552",
					d: "M182.682,682.033l-4.921,9.8-4.877-9.8h1.193l3.684,7.562,3.729-7.562Z",
					transform: "translate(-119.579 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_553",
					"data-name": "Trazado 553",
					d: "M187.424,682.033h7.085v.939h-6.04V690.4h6.04v.939h-7.085Zm6.966,5.385h-4.46v-.94h4.46Z",
					transform: "translate(-123.023 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_554",
					"data-name": "Trazado 554",
					d: "M200,691.34h-1.045v-9.307H200.7l5.891,8.427v-8.427h1.045v9.307H206l-6-8.442Z",
					transform: "translate(-125.755 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_555",
					"data-name": "Trazado 555",
					d: "M212.519,682.033H220.5v.939h-3.475v8.368h-1.044v-8.368h-3.46Z",
					transform: "translate(-128.968 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_556",
					"data-name": "Trazado 556",
					d: "M221.685,691.187l4.922-9.8,4.877,9.8h-6.667l.641-.939h4.385l-3.236-6.622-3.758,7.562Z",
					transform: "translate(-131.139 -680.971)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_557",
					"data-name": "Trazado 557",
					d: "M243.028,691.34l-2.491-4.863h1.432a1.1,1.1,0,0,0,.611-.164A1.468,1.468,0,0,0,243,685.9a1.711,1.711,0,0,0,.246-.552,2.342,2.342,0,0,0,.074-.567,2.13,2.13,0,0,0-.1-.619,2.085,2.085,0,0,0-.275-.582,1.594,1.594,0,0,0-.44-.433,1.048,1.048,0,0,0-.589-.172H237.27v8.368h-1.044v-9.307h5.891a1.887,1.887,0,0,1,.88.216,2.413,2.413,0,0,1,.731.582,2.814,2.814,0,0,1,.5.872,3.129,3.129,0,0,1,.186,1.089,2.762,2.762,0,0,1-.179.991,2.889,2.889,0,0,1-.485.836,2.362,2.362,0,0,1-.716.582,1.842,1.842,0,0,1-.872.217l1.983,3.923Z",
					transform: "translate(-134.583 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_558",
					"data-name": "Trazado 558",
					d: "M249.047,682.033h1.059v9.307h-1.059Z",
					transform: "translate(-137.62 -681.123)",
					fill: "#2e3028"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trazado_559",
					"data-name": "Trazado 559",
					d: "M253.428,686.688a3.515,3.515,0,0,0,.156,1.044,3.824,3.824,0,0,0,.44.947,3.963,3.963,0,0,0,.678.8,3.516,3.516,0,0,0,.872.582l-.656.82a4.606,4.606,0,0,1-1.029-.739,4.438,4.438,0,0,1-.783-.992,5.106,5.106,0,0,1-.5-1.178,4.683,4.683,0,0,1-.179-1.3,4.528,4.528,0,0,1,.373-1.827,4.7,4.7,0,0,1,2.505-2.5,4.771,4.771,0,0,1,3.7,0,4.7,4.7,0,0,1,2.505,2.5,4.527,4.527,0,0,1,.373,1.827,4.655,4.655,0,0,1-.187,1.32,4.7,4.7,0,0,1-.529,1.178,4.889,4.889,0,0,1-.82.984,4.418,4.418,0,0,1-1.059.723l-.552-.836a3.875,3.875,0,0,0,.865-.574,3.7,3.7,0,0,0,.686-.791,4.053,4.053,0,0,0,.448-.947,3.38,3.38,0,0,0,.164-1.044,3.471,3.471,0,0,0-.3-1.409,3.859,3.859,0,0,0-.806-1.186,3.966,3.966,0,0,0-1.185-.813,3.454,3.454,0,0,0-1.439-.306,3.5,3.5,0,0,0-1.447.306,3.929,3.929,0,0,0-1.194.813,3.842,3.842,0,0,0-.805,1.186A3.458,3.458,0,0,0,253.428,686.688Z",
					transform: "translate(-138.421 -681.109)",
					fill: "#2e3028"
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Grupo_307",
			"data-name": "Grupo 307",
			transform: "translate(46.095 658.161)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_297",
					"data-name": "Grupo 297",
					transform: "translate(37.711 20.989)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_560",
						"data-name": "Trazado 560",
						d: "M97.6,689.834a2.084,2.084,0,1,1,2.084-2.084A2.086,2.086,0,0,1,97.6,689.834Zm0-2.953a.869.869,0,1,0,.868.869A.87.87,0,0,0,97.6,686.881Z",
						transform: "translate(-95.512 -685.666)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_298",
					"data-name": "Grupo 298",
					transform: "translate(82.057 12.353)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_561",
						"data-name": "Trazado 561",
						d: "M155.707,678.518a2.084,2.084,0,1,1,2.084-2.084A2.086,2.086,0,0,1,155.707,678.518Zm0-2.953a.869.869,0,1,0,.869.869A.87.87,0,0,0,155.707,675.565Z",
						transform: "translate(-153.623 -674.349)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_299",
					"data-name": "Grupo 299",
					transform: "translate(1.481)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_562",
						"data-name": "Trazado 562",
						d: "M52.664,671.483H48.036l.009-13.321h83.3v12.961h-1.215V659.377H49.259l-.008,10.891h3.412Z",
						transform: "translate(-48.036 -658.161)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_300",
					"data-name": "Grupo 300",
					transform: "translate(30.719 3.615)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_563",
						"data-name": "Trazado 563",
						d: "M96.033,680.88H94.818V664.114l-7.254,0v4.142H86.349V662.9l9.684,0Z",
						transform: "translate(-86.349 -662.899)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_301",
					"data-name": "Grupo 301",
					transform: "translate(18.865 39.819)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_564",
						"data-name": "Trazado 564",
						d: "M72.9,714.51a2.084,2.084,0,1,1,2.084-2.085A2.087,2.087,0,0,1,72.9,714.51Zm0-2.953a.869.869,0,1,0,.869.868A.869.869,0,0,0,72.9,711.557Z",
						transform: "translate(-70.816 -710.341)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_302",
					"data-name": "Grupo 302",
					transform: "translate(0 20.989)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_565",
						"data-name": "Trazado 565",
						d: "M48.18,689.834a2.084,2.084,0,1,1,2.083-2.084A2.087,2.087,0,0,1,48.18,689.834Zm0-2.953a.869.869,0,1,0,.868.869A.87.87,0,0,0,48.18,686.881Z",
						transform: "translate(-46.095 -685.666)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_303",
					"data-name": "Grupo 303",
					transform: "translate(22.426 32.981)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_566",
						"data-name": "Trazado 566",
						d: "M93.463,710.925H75.482V709.71H92.248V702.6H88.1V701.38h5.367Z",
						transform: "translate(-75.482 -701.38)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_304",
					"data-name": "Grupo 304",
					transform: "translate(1.495 24.55)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Trazado_567",
						"data-name": "Trazado 567",
						d: "M57.734,708.317h-9.68V690.332H49.27V707.1h7.249v-3.415h1.215Z",
						transform: "translate(-48.055 -690.332)",
						fill: "#7fb02f"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Grupo_306",
					"data-name": "Grupo 306",
					transform: "translate(5.376 7.5)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Grupo_305",
						"data-name": "Grupo 305",
						children: [
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_568",
								"data-name": "Trazado 568",
								d: "M73.138,667.99H76.1v1.483H74.621v1.483H71.655v4.45H68.689v-1.483h1.483v-4.45h2.967Z",
								transform: "translate(-56.823 -667.99)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_569",
								"data-name": "Trazado 569",
								d: "M53.14,667.99v10.382H63.522V667.99Zm8.9,8.9H54.624v-7.416h7.415Z",
								transform: "translate(-53.14 -667.99)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_570",
								"data-name": "Trazado 570",
								d: "M80.35,667.99v10.382H90.732V667.99Zm8.9,8.9H81.833v-7.416h7.415v7.416Z",
								transform: "translate(-59.585 -667.99)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_555",
								"data-name": "Rect\\xE1ngulo 555",
								width: 4.45,
								height: 4.45,
								transform: "translate(2.966 2.966)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_556",
								"data-name": "Rect\\xE1ngulo 556",
								width: 4.45,
								height: 4.45,
								transform: "translate(23.73 2.966)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_557",
								"data-name": "Rect\\xE1ngulo 557",
								width: 1.483,
								height: 1.483,
								transform: "translate(16.315 4.45)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_571",
								"data-name": "Trazado 571",
								d: "M75.542,675.764h1.483V681.7H75.542V678.73H74.059v1.484H72.575v-2.966h2.967Z",
								transform: "translate(-57.744 -669.831)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_572",
								"data-name": "Trazado 572",
								d: "M67.768,679.651h1.483v1.484h1.483v1.483H69.251v2.966h1.483V684.1h1.484v-1.483H73.7v4.45H70.734v1.483H69.251v-1.483H67.768V684.1H64.8v-1.483h2.967Z",
								transform: "translate(-55.902 -670.752)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_558",
								"data-name": "Rect\\xE1ngulo 558",
								width: 2.966,
								height: 1.484,
								transform: "translate(2.966 11.865)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_573",
								"data-name": "Trazado 573",
								d: "M78.406,683.538h2.967v1.483H79.89V686.5H78.406Z",
								transform: "translate(-59.125 -671.673)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_559",
								"data-name": "Rect\\xE1ngulo 559",
								width: 1.484,
								height: 1.484,
								transform: "translate(23.73 11.865)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_574",
								"data-name": "Trazado 574",
								d: "M53.14,685.481h2.966v1.483H57.59v1.483H56.106v1.483H54.623v-2.966H53.14Z",
								transform: "translate(-53.14 -672.133)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_575",
								"data-name": "Trazado 575",
								d: "M60.914,685.481H63.88v1.483H62.4v1.483H63.88v1.483H60.914Z",
								transform: "translate(-54.982 -672.133)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_576",
								"data-name": "Trazado 576",
								d: "M85.26,685.481h1.484v1.483h1.483v4.45H86.743v-1.483H83.776v1.483H82.294v-2.966H85.26Z",
								transform: "translate(-60.046 -672.133)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_560",
								"data-name": "Rect\\xE1ngulo 560",
								width: 1.483,
								height: 1.484,
								transform: "translate(8.899 14.831)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_561",
								"data-name": "Rect\\xE1ngulo 561",
								width: 1.484,
								height: 1.484,
								transform: "translate(29.663 14.831)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_577",
								"data-name": "Trazado 577",
								d: "M66.285,689.369h1.483v2.966H64.8v-1.483h1.484Z",
								transform: "translate(-55.902 -673.054)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_562",
								"data-name": "Rect\\xE1ngulo 562",
								width: 1.484,
								height: 1.483,
								transform: "translate(17.798 16.315)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_563",
								"data-name": "Rect\\xE1ngulo 563",
								width: 1.483,
								height: 1.484,
								transform: "translate(0 17.798)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_564",
								"data-name": "Rect\\xE1ngulo 564",
								width: 1.483,
								height: 1.484,
								transform: "translate(2.966 17.798)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_578",
								"data-name": "Trazado 578",
								d: "M71.655,691.312h2.967V692.8H73.138v2.967H71.655v2.966H70.172v-2.966H68.689V692.8h1.483v1.483h1.483Z",
								transform: "translate(-56.823 -673.514)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_565",
								"data-name": "Rect\\xE1ngulo 565",
								width: 1.484,
								height: 1.484,
								transform: "translate(19.281 17.798)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_566",
								"data-name": "Rect\\xE1ngulo 566",
								width: 1.484,
								height: 1.484,
								transform: "translate(29.663 17.798)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_567",
								"data-name": "Rect\\xE1ngulo 567",
								width: 1.484,
								height: 2.966,
								transform: "translate(17.798 19.281)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_568",
								"data-name": "Rect\\xE1ngulo 568",
								width: 1.484,
								height: 2.966,
								transform: "translate(25.214 19.281)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_569",
								"data-name": "Rect\\xE1ngulo 569",
								width: 1.483,
								height: 1.483,
								transform: "translate(28.18 19.281)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_579",
								"data-name": "Trazado 579",
								d: "M79.531,695.2h1.483v1.484H82.5v2.966h4.449v1.483H81.014V704.1H79.531v-2.966H78.048v1.484H76.565V704.1h1.484v1.484H70.632V704.1h4.45v-2.966h1.483v-4.449h2.967Z",
								transform: "translate(-57.283 -674.435)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_580",
								"data-name": "Trazado 580",
								d: "M53.14,695.2v10.382H63.522V695.2Zm8.9,8.9H54.624v-7.415h7.415Z",
								transform: "translate(-53.14 -674.435)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_570",
								"data-name": "Rect\\xE1ngulo 570",
								width: 1.483,
								height: 1.483,
								transform: "translate(16.315 22.248)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_571",
								"data-name": "Rect\\xE1ngulo 571",
								width: 2.966,
								height: 1.483,
								transform: "translate(26.697 22.248)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_572",
								"data-name": "Rect\\xE1ngulo 572",
								width: 4.45,
								height: 4.45,
								transform: "translate(2.966 23.73)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_573",
								"data-name": "Rect\\xE1ngulo 573",
								width: 1.484,
								height: 1.484,
								transform: "translate(29.663 23.73)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("path", {
								id: "Trazado_581",
								"data-name": "Trazado 581",
								d: "M68.689,701.03h1.483v1.483h1.483V704H68.689Z",
								transform: "translate(-56.823 -675.816)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_574",
								"data-name": "Rect\\xE1ngulo 574",
								width: 2.966,
								height: 1.483,
								transform: "translate(14.832 25.214)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_575",
								"data-name": "Rect\\xE1ngulo 575",
								width: 1.483,
								height: 1.483,
								transform: "translate(26.697 28.18)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_576",
								"data-name": "Rect\\xE1ngulo 576",
								width: 1.484,
								height: 1.483,
								transform: "translate(29.663 28.18)",
								fill: "#7fb02f"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rect\\xE1ngulo_577",
								"data-name": "Rect\\xE1ngulo 577",
								width: 1.484,
								height: 1.484,
								transform: "translate(23.73 29.663)",
								fill: "#7fb02f"
							})
						]
					})
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgLogoAgro);
export { ForwardRef as ReactComponent };
